import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output
} from '@angular/core';
import { JobsDataServiceProvider } from '@services/job/jobs.data.service';
import { FormControl, Validators } from '@angular/forms';

@Component({
	selector: 'autocomplete-email-input',
	template: require('./autocompete-email-input.html'),
	host: {
		'(document:click)': 'closeAutocomplete($event)'
	}
})
export class AutocompleteEmailInputComponent implements OnInit {
	@Input() isRequired = true;
	@Input() isDisabled = false;
	@Input() placeholder = '';
	@Input() defaultValue = '';
	@Input() autocompleteStyle;
	@Output() actionGetEmail: EventEmitter<string> = new EventEmitter();

	searchClients = [];
	setIndex = 0;
	queryField: FormControl;
	marginTop: any;

	constructor(
		private jobsDataService: JobsDataServiceProvider,
		private _eref: ElementRef
	) {}

	ngOnInit() {
		this.initFormControll();
		this.queryField.valueChanges
			.debounceTime(200)
			.distinctUntilChanged()
			.map(query => {
				if (query.length > 0) {
					return query;
				}
				this.searchClients = [];
			})
			.switchMap(query => this.searchEmails(query))
			.subscribe((res: any) => {
				this.setIndex = 0;
				this.searchClients = res;
			});
	}

	initFormControll() {
		this.queryField = new FormControl({}, [
			Validators.email,
			Validators.maxLength(255)
		]);
		if (this.isDisabled) {
			this.queryField.disable();
		}
		this.queryField.setValue(this.defaultValue, { emitEvent: false });
		this.emitEmail();
	}

	closeAutocomplete(event) {
		if (!this._eref.nativeElement.contains(event.target)) {
			this.searchClients = [];
		}
	}

	searchEmails(queryEmail) {
		return this.jobsDataService.searchClient(queryEmail);
	}

	setEmail(item) {
		const stringEmail = item.substring(item.indexOf('(') + 1, item.length - 1);
		this.queryField.setValue(stringEmail, { emitEvent: false });
		this.emitEmail();
		this.searchClients = [];
		this.setIndex = 0;
	}

	setActive(index) {
		this.setIndex = index;
	}

	isActive(index) {
		return index === this.setIndex;
	}

	emitEmail() {
		const inputEmail = this.queryField.value;
		if (inputEmail !== undefined && inputEmail.length > 0) {
			this.actionGetEmail.emit(inputEmail);
		}
	}

	keyDownEvent(event) {
		if (this.searchClients.length !== 0) {
			let index = this.setIndex;
			switch (event.key) {
				case 'ArrowDown':
					index++;
					if (index > this.searchClients.length) {
						index = this.searchClients.length;
					}
					if (this.searchClients.length === 1) {
						index = 0;
					}
					this.setIndex = index;
					break;
				case 'ArrowUp':
					index--;
					if (index < 0) {
						index = 0;
					}
					this.setIndex = index;
					break;
				case 'Enter':
					const items = this.searchClients[this.setIndex];
					this.setEmail(items.name);
					break;
				default:
					break;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/inputs/autocomplete-email-input/autocompete-email-input.ts